module.exports = __webpack_public_path__ + "static/media/waiting-payment.a3b31434.svg";